import React from "react";

import { Recipe } from "../Components/Recipe/Recipe";

const Details = () => {
  
  return (
    <>
      <Recipe/>
    </>
  );
};

export { Details };
